"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _CreativeLayer = _interopRequireDefault(require("../../models/creative/CreativeLayer"));

var BaseRenderer = /*#__PURE__*/function () {
  /** Anything renderable to canvas */

  /** Dimension type, used to figure out how to draw bitmap to canvas */

  /** Dimension type, used to figure out how to draw bitmap to canvas */

  /** Transform mode type, used to determine how to transform the layer contents */

  /** @type { number } */

  /** @type { Number } */

  /** @type { Number } */

  /** @type { ContentStore } */

  /** @type { Number } */

  /** @type { CreativeLayer } */

  /** @type { String } */

  /** @type { FilterProcessor } */

  /** @type { LayerTransformer } */

  /**
   * @param {CreativeLayer} creativeLayer
   * @param {ContentStore} contentStore
   * @param {LayerTransformer} layerTransformer
   * @param {FilterProcessor} filterProcessor
   */
  function BaseRenderer(creativeLayer, contentStore, layerTransformer, filterProcessor) {
    (0, _classCallCheck2["default"])(this, BaseRenderer);
    (0, _defineProperty2["default"])(this, "_layerBitmap", null);
    (0, _defineProperty2["default"])(this, "_contentDimensionMode", BaseRenderer.DERIVED_DIMENSIONS);
    (0, _defineProperty2["default"])(this, "_contentScaleMode", BaseRenderer.SCALE_MODE_SCALE_TO_FIT);
    (0, _defineProperty2["default"])(this, "_contentTransformMode", BaseRenderer.TRANSFORM_APPLY);
    (0, _defineProperty2["default"])(this, "_contentHeight", 0);
    (0, _defineProperty2["default"])(this, "_contentScaleX", 1);
    (0, _defineProperty2["default"])(this, "_contentScaleY", 1);
    (0, _defineProperty2["default"])(this, "_contentStore", null);
    (0, _defineProperty2["default"])(this, "_contentWidth", 0);
    (0, _defineProperty2["default"])(this, "_creativeLayer", null);
    (0, _defineProperty2["default"])(this, "_elementId", null);
    (0, _defineProperty2["default"])(this, "_filterProcessor", null);
    (0, _defineProperty2["default"])(this, "_layerTransformer", null);
    this._creativeLayer = creativeLayer;
    this._contentStore = contentStore;
    this._layerTransformer = layerTransformer;
    this._filterProcessor = filterProcessor;
    /**
     * Note that creativeLayer is not required because the Root (stage) layer is
     * inferred and not explicit. This means this._elementId can be null.
     */

    if (_CreativeLayer["default"].isCreativeLayer(creativeLayer)) {
      this._elementId = creativeLayer.elementId;
    }
  }

  (0, _createClass2["default"])(BaseRenderer, [{
    key: "renderLayer",
    value: function renderLayer(canvasContext, frameNum) {
      // eslint-disable-line no-unused-vars
      throw new Error('Child must implement renderFrame');
    }
  }, {
    key: "layerBitmap",
    get: function get() {
      return this._layerBitmap;
    }
  }, {
    key: "contentDimensionMode",
    get: function get() {
      return this._contentDimensionMode;
    }
  }, {
    key: "contentScaleMode",
    get: function get() {
      return this._contentScaleMode;
    }
  }, {
    key: "contentTransformMode",
    get: function get() {
      return this._contentTransformMode;
    }
  }, {
    key: "contentHeight",
    get: function get() {
      return this._contentHeight;
    }
  }, {
    key: "contentScaleX",
    get: function get() {
      return this._contentScaleX;
    }
  }, {
    key: "contentScaleY",
    get: function get() {
      return this._contentScaleY;
    }
  }, {
    key: "contentWidth",
    get: function get() {
      return this._contentWidth;
    }
  }, {
    key: "creativeLayer",
    get: function get() {
      return this._creativeLayer;
    },
    set: function set(value) {
      this._creativeLayer = value;
    }
  }, {
    key: "elementId",
    get: function get() {
      return this._elementId;
    }
  }]);
  return BaseRenderer;
}();

exports["default"] = BaseRenderer;
(0, _defineProperty2["default"])(BaseRenderer, "DERIVED_DIMENSIONS", Symbol('BITMAP_DATA_DERIVED_DIMENSIONS'));
(0, _defineProperty2["default"])(BaseRenderer, "INTRINSIC_DIMENSIONS", Symbol('BITMAP_DATA_INTRINSIC_DIMENSIONS'));
(0, _defineProperty2["default"])(BaseRenderer, "SCALE_MODE_SCALE_TO_FIT", Symbol('SCALE_TO_FIT'));
(0, _defineProperty2["default"])(BaseRenderer, "SCALE_MODE_OVERFLOW", Symbol('OVERFLOW'));
(0, _defineProperty2["default"])(BaseRenderer, "TRANSFORM_APPLY", Symbol('TRANSFORM_APPLY'));
(0, _defineProperty2["default"])(BaseRenderer, "TRANSFORM_PASSTHROUGH", Symbol('TRANSFORM_PASSTHROUGH'));